import { useState } from 'react';
import ProxyButton from '../common/ProxyButton';
import { useEventBus } from '../../hooks/useEventBus';
import withEventHelper from '../common/EventHelper';
import { getLocalizedString } from '../../utils/i18n-utils';

function WebAuthnSetupButton({ oktaButton }: { oktaButton: JQuery }) {
  const [ hasError, setHasError ] = useState(false);

  useEventBus({
    eventName: 'webauthn-setup-error',
    onEvent: ({ hasError }: { hasError: boolean }) => {
      setHasError(hasError);
    },
  });

  return (
    <ProxyButton
      oktaButton={oktaButton}
      fullWidth
      textToOverride={hasError ? getLocalizedString('webauthn.try.again') : undefined}
    />
  );
}

WebAuthnSetupButton.displayName = 'WebAuthnSetupButton';
export default withEventHelper(WebAuthnSetupButton);
